import{Logger as o}from"@gamezop/gzp-frontend-common/logger";const e=new o("GZP_ADS_SDK::");export{e as Logger};
